export const PROGRESS_INSIGHTS_DEMO_ROUTE = '/progress-insights-demo';

export const DEMO_API_URL = (
    (import.meta.env.VITE_PROGRESS_INSIGHTS_DEMO_API_URL as string | undefined) ??
    'https://upheal-progress-demo.fly.dev'
).replace(/\/$/, '');

export const DEMO_PASSWORD =
    (import.meta.env.VITE_PROGRESS_INSIGHTS_DEMO_PASSWORD as string | undefined) ??
    'upheal-progress-2026';

export const DEMO_UNLOCKED_STORAGE_KEY = 'upheal-progress-demo-unlocked';
export const DEMO_SESSION_GUID_STORAGE_KEY = 'upheal-progress-demo-session-guid';
